// TODO: dictionary

import React, { useState } from "react";

import Button from "@cayuse/shared-react.components.button";
import Icon from "@cayuse/shared-react.components.icon";

import componentStyles from "./BudgetImporterComponent.css";
import { QuestionFooter, QuestionHeader } from "./Question";
import styles from "./styles.css";

function BudgetImporterComponent ({ completeFormModel, config, onChange, onDelete }) {
	const [ localConfig, setLocalConfig ] = useState(config);

	const onChangeConfig = newProps => {
		const newConfig = { ...localConfig, ...newProps };
		onChange(newConfig);
		setLocalConfig(newConfig);
	};

	return (
		<>
			<QuestionHeader config={config} onChangeConfig={onChangeConfig}></QuestionHeader>
			<div className={`ui form ${componentStyles.budgetInfoHeader}`}>
				<div className={componentStyles.budgetInfoHeaderColumn1}><strong>Budget Item</strong></div>
				<div className={componentStyles.budgetInfoHeaderColumn2}><strong>Total</strong></div>
			</div>
			<div className={`ui form ${componentStyles.budgetInfoRow}`}>
				<div className={componentStyles.budgetInfoRowColumn}><i>No Buget Information Uploaded</i></div>
			</div>
			<div className={`${styles.toolBar} ${componentStyles.label}`}>
				<label>Attached Detail Budget</label>
			</div>
			<div className={`ui form ${componentStyles.input}`}>
				<textarea
					rows={2}
					value={localConfig.attachmentDescription}
					onChange={event => onChangeConfig({ attachmentDescription: event.target.value })}
				/>
			</div>
			<div className={`ui form ${componentStyles.budgetInfoHeader}`}>
				<div className={componentStyles.budgetInfoHeaderColumn1}><strong>Name</strong></div>
				<div className={componentStyles.budgetInfoHeaderColumn2}><strong>Uploaded By</strong></div>
				<div className={componentStyles.budgetInfoHeaderColumn2}><strong>Date</strong></div>
			</div>
			<div className={`ui form ${componentStyles.budgetInfoRow}`}>
				<div className={componentStyles.budgetInfoRowColumn}><i>No budget found. Upload a budget .xls below</i></div>
			</div>
			<div className={`ui form ${componentStyles.uploadArea}`}>
				<div>
					<label>Drop files here to upload</label>
				</div>
				<div>
					or
				</div>
				<div>
					<Button primary disabled className={componentStyles.uploadButton}>
						<Icon name="upload"></Icon>Upload File
					</Button>
				</div>
			</div>
			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
			>
			</QuestionFooter>
		</>
	);
}

BudgetImporterComponent.showInPalette = () => false;

BudgetImporterComponent.paletteInformation = () => ({
	id: "cayuseResearchTeamBudgetImporter",
	name: "Budget Importer",
	type: "cayuseResearchTeamBudgetImporter",
	group: "sponsoredProject"
});

BudgetImporterComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-research-team-budget-importer",
		customStencilId: "null"
	},
	type: "cayuseResearchTeamBudgetImporter"
});


export default BudgetImporterComponent;
